export default __webpack_public_path__ + "static/DSC_0080-97cfdb10a21aecc2ecd0511cceca4237.jpg";